export const ErrorIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_650_6909)">
                <path d="M8.00032 5.33329L8.00032 7.99996M8.00032 10.6666L7.99366 10.6666M1.33366 7.99996C1.33366 4.31806 4.31843 1.33329 8.00032 1.33329C11.6822 1.33329 14.667 4.31806 14.667 7.99996C14.667 11.6819 11.6822 14.6666 8.00033 14.6666C4.31843 14.6666 1.33366 11.6819 1.33366 7.99996Z" stroke="#FF4D4D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_650_6909">
                <   rect width="16" height="16" fill="white" transform="translate(16 16) rotate(180)"/>
                </clipPath>
            </defs>
        </svg>
    );
}